<div class="row" style="margin-top: 10px;">
  <div class="col-xs-12" style="padding-left: 5px; padding-right:5px;">
    <div class="form-group">
      <label>{{'main.navigation.alerts.alert_type' | translate}}</label>
      <rdo-multiselect-dropdown
        [disabled]="alertTypeMultiSelectDisabled"
        [texts]="alertTypeSelectionTexts"
        [settings]="alertTypeSelectSettings"
        [options]="alertTypes()"
        [(ngModel)]="selectedAlertTypeIds"
        (ngModelChange)="alertCriteriaChange()"
        />
    </div>
  </div>
</div>

<div class="row">
  <div class="col-xs-12" style="padding-left: 5px; padding-right:5px;">
    <div class="form-group">
      <label>{{'main.navigation.alerts.geography.title' | translate}}</label>
      <rdo-multiselect-dropdown
        [disabled]="geographyMultiSelectDisabled"
        [(texts)]="geographyMultiSelectTexts"
        [settings]="geographyMultiSelectSettings"
        [options]="alertGeographies()"
        [(ngModel)]="selectedAlertGeographyIds"
        (ngModelChange)="alertCriteriaChange()"
        />
    </div>
  </div>
</div>

<div class="row" id="alert-checkboxes" style="padding: 0px 5px;">
  <div class="rdo-checkbox" style="float: left; width: 50%; padding-left: 5px;">
    <div class="checkbox">
      <label>
        <input style="display: none;" type="checkbox" [(ngModel)]="hideReadAlerts" (ngModelChange)="alertCriteriaChange(true)" />
        <span style="line-height: inherit; max-width: 87%;">{{'main.navigation.alerts.hide_read' | translate}}</span>
      </label>
    </div>
  </div>

  <div class="rdo-checkbox" style="float: right; width: 50%; padding-left: 5px;">
    <div class="checkbox">
      <label>
        <input style="display: none;" type="checkbox" [(ngModel)]="hideClearedAlerts" (ngModelChange)="alertCriteriaChange(true)" />
        <span style="line-height: inherit; max-width: 87%;">{{'main.navigation.alerts.hide_resolved_from_last_period' | translate}}</span>
      </label>
    </div>
  </div>
</div>
<!-- alerts dropdown -->
@if (isOpen()) {
  <div class="row" style="flex-grow: 1; overflow: hidden;" >
    <div class="col-xs-12" style="padding-left: 5px; padding-right:5px; height: 100%; display: flex; flex-direction: column;">
      <div class="notifications"
        infinite-scroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="500"
        (scrolled)="getPaginatedAlerts()"
        [infiniteScrollContainer]="scrollableNotificationList"
        [scrollWindow]="false">
        <ul class="notification-list" [class.hide]="isAlertNotificationListHidden">
          @for (alert of alerts() | rdoAlerts: hideReadAlerts : hideClearedAlerts; track alert; let i = $index) {
            <li class="bs-callout" style="border-left-width: 1px;"
              [class.active]="selectedAlert && selectedAlert.AlertID === alert.AlertID"
              [class.hide]="hideReadAlerts && selectedAlert && selectedAlert.AlertID !== alert.AlertID && alert.AlertStatus === 2"
              (click)="handleAlertClick(i, alert)">
              <div class="media">
                <div class="media-left">
                  <rdo-category-icon [category]="alert.CategoryIcon || alert.RouseCategory" />
                </div>
                <div class="media-body">
                  <p class="heading truncate">{{!!alert.UseRouseSchema ? alert.RouseProductType : alert.Description}}</p>
                  <p class="sub-text truncate">
                  {{'main.navigation.alerts.geography.title' | translate}}:&nbsp;{{alert.Geography}}</p>
                  <div class="rdo-card-metric">
                    {{alert.RevenueBenchmarked | rdoCurrency:true}} / <span [ngClass]="{'text-danger' : alert.RevenueDifference < 0}">
                    {{alert.RevenueDifference | rdoCurrency:true}}
                  </span>
                  <div class="pull-right">
                    <span [rdo-dynamic-pie]="alert.PhysicalUtilizationTotal * 100" class="pie"></span>
                    <span class="text-default">&nbsp;{{alert.PhysicalUtilizationTotal | percent:'1.1-1'}}</span>
                  </div>
                </div>
              </div>
              <div class="media-right">
                @if (alert.IsCleared) {
                  <div>
                    @if (alert.AlertStatus !== 2) {
                      <i [attr.id]="'alert-icon' + i" class="fa fa-fw fa-lg fa-thumbs-o-up"
                      data-toggle="tooltip" data-placement="left" title="{{'main.navigation.alerts.resolved_from_last_period' | translate}}"></i>
                    }
                    @if (alert.AlertStatus === 2) {
                      <span [attr.id]="'alert-icon' + i" class="fa-stack" data-toggle="tooltip"
                        data-placement="left" title="{{'main.navigation.alerts.resolved_from_last_period' | translate}}">
                        <i class="fa fa-circle fa-stack-2x text-success"></i>
                        <i class="fa fa-thumbs-o-up fa-stack-1x text-white"></i>
                      </span>
                    }
                  </div>
                }
                @if (!alert.IsCleared) {
                  <div>
                    @if (alert.NumPeriodNotCleared >= 6 && alert.AlertStatus !== 2) {
                      <i [attr.id]="'alert-icon' + i"
                        class="fa fa-fw fa-lg fa-fire text-danger"
                        data-toggle="tooltip" data-placement="left" [attr.title]="'main.navigation.alerts.unresolved_for_6_or_more_periods' | translate">
                      </i>
                    }
                    @if (alert.NumPeriodNotCleared > 1 && alert.NumPeriodNotCleared < 6 && alert.AlertStatus !== 2) {
                      <i [attr.id]="'alert-icon' + i"
                        class="fa fa-fw fa-lg fa-fire text-danger"
                        data-toggle="tooltip" data-placement="left" [attr.title]="getUnresolvedForText(alert.NumPeriodNotCleared)">
                      </i>
                    }
                    @if (alert.NumPeriodNotCleared >= 6 && alert.AlertStatus === 2) {
                      <span [attr.id]="'alert-icon' + i" class="fa-stack"
                        data-toggle="tooltip" data-placement="left" [attr.title]="'main.navigation.alerts.unresolved_for_6_or_more_periods' | translate">
                        <i class="fa fa-circle fa-stack-2x text-success"></i>
                        <i class="fa fa-fire fa-stack-1x text-white"></i>
                      </span>
                    }
                    @if (alert.NumPeriodNotCleared > 1 && alert.NumPeriodNotCleared < 6 && alert.AlertStatus === 2) {
                      <span [attr.id]="'alert-icon' + i" class="fa-stack"
                        data-toggle="tooltip" data-placement="left" [attr.title]="getUnresolvedForText(alert.NumPeriodNotCleared)">
                        <i class="fa fa-circle fa-stack-2x text-success"></i>
                        <i class="fa fa-fire fa-stack-1x text-white"></i>
                      </span>
                    }
                    @if (alert.NumPeriodNotCleared <= 1 && alert.AlertStatus !== 2) {
                      <i [attr.id]="'alert-icon' + i" class="fa fa-fw fa-lg fa-warning text-warning"
                      data-toggle="tooltip" data-placement="left" title="{{'main.navigation.alerts.new_alert_this_period' | translate}}"></i>
                    }
                    @if (alert.NumPeriodNotCleared <= 1 && alert.AlertStatus === 2) {
                      <span [attr.id]="'alert-icon' + i" class="fa-stack"
                        data-toggle="tooltip" data-placement="left" title="{{'main.navigation.alerts.new_alert_this_period' | translate}}">
                        <i class="fa fa-circle fa-stack-2x text-success"></i>
                        <i class="fa fa-warning fa-stack-1x text-white"></i>
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
}

